<template>
    <div ref="container" class="turnstile-widget"></div>
</template>

<script>
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const LOAD_TIMEOUT_MS = 15000

function loadTurnstile() {
    if (window.turnstile) {
        return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
        const started = Date.now()
        const existing = document.querySelector(`script[src*="challenges.cloudflare.com/turnstile"]`)
        if (!existing) {
            const script = document.createElement('script')
            script.src = SCRIPT_SRC
            script.async = true
            script.defer = true
            script.onerror = () => reject(new Error('Turnstile failed to load'))
            document.head.appendChild(script)
        }
        const timer = setInterval(() => {
            if (window.turnstile) {
                clearInterval(timer)
                resolve()
                return
            }
            if (Date.now() - started > LOAD_TIMEOUT_MS) {
                clearInterval(timer)
                reject(new Error('Turnstile failed to load'))
            }
        }, 50)
    })
}

export default {
    name: 'TurnstileWidget',
    props: {
        action: {
            type: String,
            required: true
        }
    },
    emits: ['verify', 'expire', 'error'],
    data() {
        return {
            widgetId: null
        }
    },
    async mounted() {
        try {
            await loadTurnstile()
            if (!this.$refs.container) {
                return
            }
            this.widgetId = window.turnstile.render(this.$refs.container, {
                sitekey: process.env.VUE_APP_TURNSTILE_SITEKEY,
                action: this.action,
                theme: 'dark',
                callback: (token) => {
                    this.$emit('verify', token)
                },
                'expired-callback': () => {
                    this.$emit('expire')
                },
                'error-callback': () => {
                    this.$emit('error')
                }
            })
        } catch {
            this.$emit('error')
        }
    },
    beforeUnmount() {
        if (this.widgetId != null && window.turnstile) {
            window.turnstile.remove(this.widgetId)
            this.widgetId = null
        }
    },
    methods: {
        reset() {
            if (this.widgetId != null && window.turnstile) {
                window.turnstile.reset(this.widgetId)
            }
        }
    }
}
</script>

<style scoped>
.turnstile-widget {
    display: flex;
    justify-content: center;
    margin: 0 0 20px;
    min-height: 65px;
}
</style>
